/**
 * @deprecated utilse l'interface  le model de shared-lib/src/lib/models **/
export enum CombisType {
    MANDATORY = 'MANDATORY',
    OPTIONAL = 'OPTIONAL',
    PSEUDO_MANDATORY = 'PSEUDO_MANDATORY',
}
